/* TITAN PLAYER SCAN 結果ビュー
   2026-07-24: ケース(見た目)選択を追加 */
(function createTitanScanResultView() {
  'use strict';

  function detail(label, value) {
    const wrapper = document.createElement('div');
    const term = document.createElement('dt');
    const description = document.createElement('dd');
    term.textContent = label;
    description.textContent = value;
    wrapper.append(term, description);
    return wrapper;
  }

  const CASE_VISIBLE = 5; /* 初期表示件数。残りは「すべて見る」で展開 */

  /* ケース(見た目)選択を描画。クリックで価格とCTAリンクを差し替える */
  function renderCases(refs, data, product, logic) {
    const box = refs.caseBox;
    if (!box) return;
    const all = (data.cases || {})[product.id];
    if (!all || all.length < 2) { box.hidden = true; box.innerHTML = ''; return; }

    /* 価格昇順。差額は最安ケースを基準にした相対表示 */
    const list = all.slice().sort((a, b) => a.p - b.p);
    const base = list[0] ? list[0].p : 0;
    /* 選択中が初期表示の外なら繰り上げて必ず見えるようにする */
    let sel = list.findIndex((v) => v.u === product.url || v.h === product.id);
    if (sel >= CASE_VISIBLE) {
      const picked = list.splice(sel, 1)[0];
      list.splice(CASE_VISIBLE - 1, 0, picked);
      sel = CASE_VISIBLE - 1;
    }
    const hidden = Math.max(0, list.length - CASE_VISIBLE);

    const items = list.map((v, i) => {
      const on = i === sel;
      const diff = v.p - base;
      const diffText = diff === 0 ? '差額なし' : `+${logic.formatYen(diff)}`;
      const img = v.i
        ? `<img src="${v.i}" alt="" loading="lazy" decoding="async" width="88" height="88">`
        : '<span class="tps-case__noimg" aria-hidden="true">—</span>';
      return `<button type="button" class="tps-case__item${on ? ' is-on' : ''}${i >= CASE_VISIBLE ? ' is-extra' : ''}"`
        + ` role="radio" aria-checked="${on ? 'true' : 'false'}" tabindex="${on ? '0' : '-1'}"`
        + ` data-u="${v.u}" data-p="${v.p}">`
        + `<span class="tps-case__img">${img}</span>`
        + `<span class="tps-case__name">${v.n}</span>`
        + `<span class="tps-case__diff">${diffText}</span>`
        + `<span class="tps-case__mark">選択中</span>`
        + '</button>';
    }).join('');

    box.hidden = false;
    box.innerHTML = '<div class="tps-case__head">'
      + '<span class="tps-case__title">ケース（見た目）を選ぶ</span>'
      + `<span class="tps-case__count">全${list.length}種</span></div>`
      + `<div class="tps-case__grid" role="radiogroup" aria-label="ケースを選ぶ">${items}</div>`
      + (hidden > 0 ? `<button type="button" class="tps-case__more" aria-expanded="false">すべてのケースを見る（全${list.length}種）</button>` : '');

    if (box.dataset.bound) return;
    box.dataset.bound = '1';
    box.addEventListener('click', (e) => {
      const more = e.target.closest('.tps-case__more');
      if (more) {
        box.classList.add('is-expanded');
        more.setAttribute('aria-expanded', 'true');
        more.remove();
        return;
      }
      const btn = e.target.closest('.tps-case__item');
      if (!btn) return;
      box.querySelectorAll('.tps-case__item').forEach((b) => {
        b.classList.remove('is-on');
        b.setAttribute('aria-checked', 'false');
        b.setAttribute('tabindex', '-1');
      });
      btn.classList.add('is-on');
      btn.setAttribute('aria-checked', 'true');
      btn.setAttribute('tabindex', '0');
      const price = parseInt(btn.dataset.p, 10) || 0;
      if (refs.productPrice) refs.productPrice.textContent = logic.formatYen(price);
      if (refs.productLink && btn.dataset.u) refs.productLink.href = btn.dataset.u;
    });
  }

  function render(refs, state, result, data, logic) {
    const answers = state.answers;
    const product = result.recommendation.product;
    refs.playerClass.textContent = result.playerClass;
    refs.playerType.textContent = result.playerType;
    refs.resultSummary.textContent = result.summary;
    refs.inputScoreLabel.textContent = result.inputLabel;
    refs.resultDetails.replaceChildren(
      detail('使用端末', result.deviceLabel),
      detail('ゲーム', result.gameName),
      detail('プレイスタイル', data.labels.styles[answers.style]),
      detail('モニター', `${answers.monitorHz}Hz${answers.monitorHz === 360 ? '以上' : ''}`),
      detail('予算', answers.budgetUnlimited ? '上限なし' : logic.formatYen(answers.budget)),
      detail('優先度', data.labels.priorities[answers.priority]),
      detail('配信・編集', data.labels.streaming[answers.streaming]),
      detail(
        state.device.mode === 'touch' ? 'タップ / 誤タップ' : '命中 / ミス',
        `${state.metrics.hits} / ${state.metrics.misses}`,
      ),
      ...(state.device.mode === 'touch'
        ? [
            detail(
              '平均タップ間隔',
              state.metrics.averageInterval === null ? '—' : `${state.metrics.averageInterval}ms`,
            ),
            detail(
              '最速タップ間隔',
              state.metrics.fastestInterval === null ? '—' : `${state.metrics.fastestInterval}ms`,
            ),
          ]
        : []),
    );
    refs.analysisComments.replaceChildren(
      ...result.comments.map((comment) => {
        const paragraph = document.createElement('p');
        paragraph.textContent = comment;
        return paragraph;
      }),
    );
    const budgetCriterion = answers.budgetUnlimited ? '予算上限なし' : '予算';
    refs.recommendationReason.textContent = `${result.gameName}の負荷、${data.labels.priorities[answers.priority]}、${answers.monitorHz}Hz環境、配信用途、${budgetCriterion}の順に照合した構成です。`;
    refs.recommendedGpu.textContent = result.recommendation.gpu;
    refs.recommendedCpu.textContent = result.recommendation.cpu;
    refs.recommendedMemory.textContent = `${result.recommendation.memoryGb}GB`;
    refs.recommendedMonitor.textContent = result.recommendation.monitor;
    refs.recommendedPrice.textContent = result.recommendation.priceBand.label;
    refs.budgetNote.textContent = answers.budgetUnlimited
      ? product.gpuRank < result.recommendation.gpuRank
        ? '予算上限なしで性能条件を優先し、掲載モデルから最も近いGPU構成を表示しています。'
        : '予算上限なしで、性能条件に最も近い掲載モデルを表示しています。'
      : result.recommendation.budgetDelta > 0
      ? product.gpuRank < result.recommendation.gpuRank
        ? `掲載商品は予算より${logic.formatYen(result.recommendation.budgetDelta)}上で、診断GPUにも届かない近似候補です。`
        : `最も近い掲載商品は予算より${logic.formatYen(result.recommendation.budgetDelta)}上です。`
      : product.gpuRank < result.recommendation.gpuRank
        ? '掲載商品は予算内の近似候補です。診断GPUへ上げる場合は構成と価格を確認してください。'
        : '掲載商品はベース構成です。診断CPU・メモリと異なる場合は商品ページで確認してください。';
    const matchingCard = refs.productCards.find((card) => card.dataset.productCard === product.id);
    refs.productCards.forEach((card) => {
      card.hidden = card !== matchingCard;
    });
    refs.productFallback.hidden = Boolean(matchingCard);
    refs.selectedProductName.textContent = product.name;
    refs.selectedProductStatus.textContent = product.available === false
      ? '現在このベース商品は在庫切れです。近い構成は商品一覧で確認できます。'
      : '価格・構成・在庫は商品ページの最新情報を表示しています。';
    if (!matchingCard) {
      delete refs.productImage.dataset.fallbackApplied;
      refs.productImage.src = product.image;
      refs.productImage.alt = `${product.name}の製品画像`;
      refs.productStatus.textContent = `NEW / ${product.caseColor.toUpperCase()}`;
      refs.productName.textContent = product.name;
      refs.productDescription.textContent = product.description;
      refs.productPrice.textContent = logic.formatYen(product.priceMin);
    }
    refs.catalogDate.textContent = '表示価格と在庫状況は、商品ページの現在値が優先されます。';
    refs.productLink.href = product.url;
    renderCases(refs, data, product, logic);
    refs.radarSummary.replaceChildren(
      ...result.radar.labels.map((label, index) => {
        const item = document.createElement('li');
        item.textContent = `${label}: ${result.radar.values[index]} / 100`;
        return item;
      }),
    );
  }

  window.TitanScanResultView = Object.freeze({ render });
})();
